export default __webpack_public_path__ + "static/media/avatar1.f99dff06.jpeg";